import React, { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import SpecialOffersPreview from './SpecialOffersPreview';

const SpecialOffersLivePreviewRoot = (props) => {
    const [specialOffer, setSpecialOffer] = useState(null);
    const [lang, setLang] = useState(null);

    useEffect(() => {
        document.addEventListener('special-offers-preview-update', updateLivePreview);
        document.addEventListener('i118n_input_select_lang', updateLiveLang);
        document.dispatchEvent(new Event("special-offers-preview-mounted"));
		return () => {
            document.removeEventListener('special-offers-preview-update', updateLivePreview);
            document.removeEventListener('i118n_input_select_lang', updateLiveLang);
		};
    }, []);

	const updateLivePreview = (event) => {
		const { detail: specialOffer } = event;
		setSpecialOffer(specialOffer);
	}

    const updateLiveLang = (event) => {
		const { detail: lang } = event;
		setLang(lang);
	}

    return <SpecialOffersPreview specialOffer={specialOffer} lang={lang} {...props} />
}

export default SpecialOffersLivePreviewRoot

if(typeof window.SpecialOffersLivePreviewRoots == 'undefined') {
    window.SpecialOffersLivePreviewRoots = {};
}

// MOUNT/UNMOUNT OK
window.SpecialOffersLivePreviewRoot = function (sectionTag = 'global') {
    const elements = document.querySelectorAll('[data-react="requests_hotels-special-offers-preview"]');

    elements.forEach(element => {
        const uniqueId = element.dataset.windowId || sectionTag;

        if (window.SpecialOffersLivePreviewRoots[uniqueId] && window.SpecialOffersLivePreviewRoots[uniqueId].unmount) {
            window.SpecialOffersLivePreviewRoots[uniqueId].unmount();
        }

        let attr = {
            sectionTag,
            windowId: uniqueId,
        };

        const root = createRoot(element);
        root.render(<SpecialOffersLivePreviewRoot {...attr} />);

        window.SpecialOffersLivePreviewRoots[uniqueId] = root;
    });
};